// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"354":"dbcbe88e","627":"60f2122c","628":"059655e3","737":"dff4792e","782":"4c84e987","942":"8fcedbf5","945":"bf37c527"}[chunkId] + ".chunk.css";
};